import { useTranslation } from 'react-i18next';
import { useActor } from '@xstate/react';
import { RetryPaymentStatusEnum } from 'obt-common';
import useRetryPaymentService from '../xstate/useRetryPaymentService';

export interface SubmitButtonProps {
  status: RetryPaymentStatusEnum;
  text: string;
}

/**
 * Returns the props to render the button's text based on current state in the
 * retry payment flow
 */
const useSubmitButtonProps = (): SubmitButtonProps => {
  const { t: tt } = useTranslation('WEB');
  const retryPaymentMachine = useRetryPaymentService();
  const [state] = useActor(retryPaymentMachine);

  if (state.matches('retryPayment') || state.matches('3dSecure2')) {
    return {
      status: RetryPaymentStatusEnum.RETRYING_PAYMENT,
      text: tt('Retrying Payment'),
    };
  }

  if (state.matches('retryPaymentRevalidate') || state.matches('fareChanged')) {
    return {
      status: RetryPaymentStatusEnum.REVALIDATING_PRICE,
      text: tt('Confirming Price'),
    };
  }

  if (state.matches('failure')) {
    return {
      status: RetryPaymentStatusEnum.RETRY_FAILED,
      text: tt('Retry Payment'),
    };
  }

  if (state.matches('success')) {
    return {
      status: RetryPaymentStatusEnum.RETRY_SUCCESS,
      text: tt('Retry Successful!'),
    };
  }

  return {
    status: RetryPaymentStatusEnum.NOT_STARTED,
    text: tt('Retry Payment'),
  };
};

export default useSubmitButtonProps;
